export default function BusinessSection() {
  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const handleContactScroll = () => {
    const ctaSection = document.querySelector('[data-cta-section]');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const businesses = [
    {
      icon: "🚁",
      title: "農業ドローン",
      description: "DJI農業ドローン販売・サポート",
      action: () => handleNavigation('/drones')
    },
    {
      icon: "🚜",
      title: "自動操舵",
      description: "FJD・EFIX自動操舵販売・サポート",
      action: () => handleNavigation('/auto-steering')
    },
    {
      icon: "💧",
      title: "水管理",
      description: "Farmo水管理システム販売・サポート",
      action: () => handleNavigation('/water-management')
    },
    {
      icon: "📋",
      title: "スクール",
      description: "農業ドローン協議会認定スクール運営",
      action: () => handleNavigation('/school')
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            私たちができること
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {businesses.map((business, index) => (
            <div 
              key={index} 
              className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-8 text-center border border-green-100 hover:shadow-lg transition-all cursor-pointer group"
              onClick={business.action}
            >
              <div className="text-4xl mb-6">{business.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#2A6041] transition-colors">
                {business.title}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                {business.description}
              </p>
              <div className="flex items-center justify-center text-[#2A6041] font-medium group-hover:text-[#1a4029] transition-colors">
                <span className="mr-2">詳しく見る</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
